import { render } from "./DefBuy.vue?vue&type=template&id=6ca6417d&scoped=true"
import script from "./DefBuy.vue?vue&type=script&lang=js"
export * from "./DefBuy.vue?vue&type=script&lang=js"

import "./DefBuy.vue?vue&type=style&index=0&id=6ca6417d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca6417d"]])

export default __exports__